import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowDialog = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("polyline", { points: "14 3 21 3 21 10" }),
		/* @__PURE__ */ _jsx("line", {
			x1: 10,
			y1: 14,
			x2: 21,
			y2: 3
		}),
		/* @__PURE__ */ _jsx("path", { d: "M21 21H5a2 2 0 0 1-2-2V5" })
	]
});
export default SvgArrowDialog;
